import styled from 'styled-components';
import { resetBtn, size } from 'styled-manila';

const breakpoint = '(min-width: 620px)';

export const Wrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: ${props => props.zOverride ? props.zOverride : '99999'};
	color: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	overflow: hidden;
	padding: 0;
	box-sizing: border-box;

	*, *:before, *:after {
		box-sizing: inherit;
	}

	@media ${breakpoint} {
		padding: 32px 8px 40px;
	}
`;

export const OuterWrapper = styled.div`
	z-index: 2;
	overflow-y: ${({ noOverflow }) => noOverflow ? 'hidden' : 'auto'};
	max-width: 100%;
	height: 100%;
`;

export const InnerWrapper = styled.div`
	height: 100%;
	@media ${breakpoint} {
		height: calc(100% - 72px); /* Wrapper padding 32+40 */
	}
`;

export const Background = styled.div`
	background-color: rgba(0, 0, 0, 0.5);
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: -1;
`;

export const CloseBtn = styled.button`
	${resetBtn};
	color: rgb(210, 210, 210);
	background-color: rgba(22, 22, 23, 0.25);
	${size(44)};
	position: absolute;
	top: 0;
	right: 0;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: color 0.2s;
	box-shadow: none;

	&:hover, &:active, &:focus {
		color: white;
	}
`;
